import React from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const [, navigate] = useLocation();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4">
            {/* PatternIQ Logo Spinner */}
            <svg
              viewBox="0 0 60 60"
              className="w-16 h-16 text-primary animate-spin"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="30" cy="30" r="4" stroke="currentColor" strokeWidth="2" opacity="0.3" />
              <circle cx="30" cy="30" r="4" stroke="currentColor" strokeWidth="2" strokeDasharray="25" strokeDashoffset="25">
                <animate attributeName="stroke-dashoffset" values="25;0" dur="1s" repeatCount="indefinite" />
              </circle>
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">PatternIQ</h1>
          <div className="animate-pulse">
            <div className="h-2 bg-muted rounded w-32 mx-auto"></div>
            <div className="h-2 bg-muted rounded w-24 mx-auto mt-2"></div>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    navigate('/login');
    return null;
  }

  // Render protected content if authenticated
  return <>{children}</>;
}
